import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { apiFetch } from "../../utils/api.js";
import Loader from "../Common/Loader.js"; // adjust path if needed

const ForgotPassword = () => {
  const [tokenNo, setTokenNo] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgot = async () => {
    if (!tokenNo) {
      toast.error("Please enter your Token Number");
      return;
    }

    setLoading(true); // 🔵 show loader

    try {
      const data = await apiFetch("/api/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({ token_no: tokenNo }), // ✅ match backend
      });

      toast.success(data.message || "Check your email for reset link");

      // 🔵 redirect after short delay so user can see toast
      setTimeout(() => {
        navigate("/signin");
      }, 2000);
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Error sending reset link");
    } finally {
      setLoading(false); // 🔵 hide loader
    }
  };

  return (
    <div className="auth-container">
      {loading && <Loader />} {/* 🔵 show loader overlay */}
      <div className="auth-content">
        <h2>Forgot Password</h2>
        <input
          type="text"
          placeholder="Enter your Token No"
          value={tokenNo}
          onChange={(e) => setTokenNo(e.target.value)}
        />
        <button
          onClick={handleForgot}
          style={{ marginTop: "30px" }}
          disabled={loading} // 🔵 prevent multiple clicks
        >
          {loading ? "Processing..." : "Send Reset Link"}
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
